import * as React from 'react'

import { Tabs } from '../tabs/Tabs'

export const SegmentedControlContent = Tabs.Content
